import { useInfiniteQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import * as Comments from "./getQueryKey";

interface UseRecentCommentsParams {
  enabled?: boolean;
}

export function getQueryKey() {
  return [...Comments.getQueryKey(), "recent"];
}

/**
 * Fetches the most recent components for the org
 */
export function useRecentComments(params: UseRecentCommentsParams = {}) {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();
  const { enabled = true } = params;

  return useInfiniteQuery({
    queryKey: getQueryKey(),
    queryFn: async ({ pageParam, signal }) => {
      if (!currentOrganization) {
        throw new Error("No organization selected");
      }

      return commentService.getRecentComments({
        orgId: currentOrganization.org_id,
        pageToken: pageParam,
        abortSignal: signal,
      });
    },
    select: (data) => data.pages.flatMap((page) => page.items),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_token,
    enabled: enabled && currentOrganization !== null,
    staleTime: 60000, // 1 minute
  });
}
